module.exports = __webpack_public_path__ + "static/voucher-b0860e472e89fb4c52835b5f85d42f3f.jpg";